"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { trackMetaPixel } from "@/lib/meta-pixel";

/**
 * Fires a Meta Pixel PageView on App Router client-side navigations.
 * The initial page load's PageView comes from the base snippet in the
 * root layout, so the first pathname render is skipped.
 */
export function MetaPixelPageView() {
  const pathname = usePathname();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackMetaPixel("PageView");
  }, [pathname]);

  return null;
}
